import classnames from "classnames";
import ControlButton from "ControlButton";
import PropTypes from "prop-types";
import React from "react";

export default class ChapterButtonComponent extends React.Component {
  static propTypes = {
    border: PropTypes.bool,
    chapterNumber: PropTypes.number.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    on: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    showChapterButtons: PropTypes.bool.isRequired,
    style: PropTypes.object,
  };

  static defaultProps = {
    border: true,
    className: "",
    disabled: false,
  };

  render() {
    const classNameModifiers = classnames("chapter", {
      on: this.props.on,
    });

    let component = null;

    if (this.props.showChapterButtons) {
      component = (
        <ControlButton
          border={this.props.border}
          className={this.props.className}
          classNameModifiers={classNameModifiers}
          disabled={this.props.disabled}
          onClick={this.props.onClick}
          style={this.props.style}
          text={this.props.chapterNumber}
        />
      );
    }

    return component;
  }
}
